import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import * as fromRoot from '@core/redux';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-burger',
  templateUrl: './burger.component.html',
  styleUrls: ['./burger.component.less'],
  imports: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BurgerComponent {
  private readonly store = inject<Store<fromRoot.State>>(Store);

  protected readonly count = toSignal(
    this.store.select(fromRoot.getNotificationsTask).pipe(
      map(tasks => {
        if (!tasks) {
          return 0;
        }
        return tasks.reduce((acc, task) => acc + (task.countNotifications ?? 0), 0);
      })
    ),
    { initialValue: 0 }
  );
}
